import styled from "styled-components";
import {VOUCHER_CARD_WIDTH} from "../../../../../../../free-play/voucher-card-css-constants";

export const GamePlayPcHeaderBarAvailableVouchersListTitleBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    width: 100%;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 1.5rem;
    max-width: ${VOUCHER_CARD_WIDTH};
    
`